<script>
    export let position = "";

    import { t } from "../i18n/i18n";

    import { code } from '../store.js'
    import { PlayFilledAlt } from "carbon-icons-svelte";
    export let zone_focus;
    export let _code;
    export let _zone;
</script>

<div id="pin-{_code}" 
        class='pin {_zone} {zone_focus?"zone-focusing":""}' 
        style={position} 
        on:keypress={()=>{}}
        on:click={() => {
            $code = _code;
            gtag('event', 'ag_click', {
                'code': _code.replace('Z1AG1','Z0AG1') + $t('audio.suffix'),
            });
        }}>
    {#if _code == $code}
        <div class="playing-effect">
            <img src='./assets/images/volume_0.png' alt/> 
            <img src='./assets/images/volume_1.png' alt/> 
            <img src='./assets/images/volume_2.png' alt/> 
            <img src='./assets/images/volume_3.png' alt/> 
        </div>
    {:else}
        <div class='to-play'>
            <PlayFilledAlt/>
        </div>
    {/if}
</div>

<style lang="scss">
    .Z1 {
        --theme-color: #58595b;
    }
    .Z2 {
        --theme-color: red;
    }
    .Z3 {
        --theme-color: #093366;
    }
    .Z4 {
        --theme-color: #662d91;
    }
    .Z5 {
        --theme-color: #55b4c8;
    }
    .Z6 {
        --theme-color: #f7941d;
    }
    
    .pin{
        color: white;
        position: absolute;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        z-index: 2;

        width: 20px;
        height: 20px;

        img {
            width: 32px;
            height: 32px;
        }

        &.audio-paused{
            .bar{
                animation-play-state: paused;
            }

            & > img {
                animation-play-state: paused;
            }
        }

        &:not(.zone-focusing){
            opacity: 0.2;
        }

        .to-play {
            display: flex;
            justify-content: center;
            align-items: center;
            color: var(--theme-color);
            background-color: white;
            --to-play-size: 22px;
            min-width: var(--to-play-size);
            min-height: var(--to-play-size);
            max-width: var(--to-play-size);
            max-height: var(--to-play-size);
            border-radius: 16px;
            border: 2px solid var(--theme-color);

            box-shadow: 0 0 5px 1px #0006;
        }

        .playing-effect{
            display: flex;
            justify-content: center;
            align-items: center;
            column-gap: 1px;
            height: 20px;
            width: 32px;

            & > img {
                position: absolute;
                width: 45px;
                height: 34px;
                animation-duration: 1.5s;
                animation-iteration-count: infinite;
                animation-timing-function: linear;

                &:nth-child(1){
                    animation-name: anim-play-1;
                }
                &:nth-child(2){
                    animation-name: anim-play-2;
                }
                &:nth-child(3){
                    animation-name: anim-play-3;
                }
                &:nth-child(4){
                    animation-name: anim-play-4;
                }
            }
        }

        @keyframes anim-play-1{
            0%{
                display: none;
            }
            20%{
                display: block;
            }
            80%{
                display: block;
            }
            100%{
                display: none;
            }
        }
        @keyframes anim-play-2{
            0%{
                display: none;
            }
            20%{
                display: none;
            }
            40%{
                display: block;
            }
            80%{
                display: block;
            }
            100%{
                display: none;
            }
        }
        @keyframes anim-play-3{
            0%{
                display: none;
            }
            40%{
                display: none;
            }
            60%{
                display: block;
            }
            80%{
                display: block;
            }
            100%{
                display: none;
            }
        }
        @keyframes anim-play-4{
            0%{
                display: none;
            }
            60%{
                display: none;
            }
            80%{
                display: block;
            }
            100%{
                display: none;
            }
        }
    }
</style>